module.exports = __webpack_public_path__ + "static/media/preview_image_DELETE.c65c5627.png";